/* eslint-disable no-param-reassign */
export default (state, { error }) => {
  state.error = error.message;
};
